import React, { useContext } from "react";
import Toast from "../ui/Toast";
import { ToastContext } from "../contexts/ToastContext";

/**
 * ToastContainer - Renders all active toasts from the context
 * Should be placed once in the app (e.g., in App.js)
 */
export default function ToastContainer() {
  const context = useContext(ToastContext);

  if (!context) {
    return null; // ToastProvider not mounted
  }

  const { toasts, removeToast } = context;

  // Stack multiple toasts vertically
  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 md:translate-x-0 md:top-auto md:left-auto md:bottom-4 md:right-4 z-50 flex flex-col gap-3">
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            show={true}
            onClose={() => removeToast(toast.id)}
            message={toast.message}
            variant={toast.variant}
            duration={0} // Duration is handled by context
            onRetry={toast.onRetry}
            retryLabel={toast.retryLabel}
          />
        </div>
      ))}
    </div>
  );
}
